
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8.25 11.153a5 5 0 100-10 5 5 0 000 10z"}}),_c('path',{attrs:{"d":"M8.249 9.153a3 3 0 100-6 3 3 0 000 6zM11.25 10.153v5l-3-1.5-3 1.5v-5"}})])])
          )
        }
      }
    